import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { EditAccountProductVm, ProductVm } from '../../models';
import { AccountProductService } from '../account-product.service'

@Component({
    selector: 'account-product-edit',
    templateUrl: './account-product-edit.component.html',
})
export class AccountProductEditComponent implements OnInit {
    @ViewChild('formElement') formElement: FormGroup;
        model: EditAccountProductVm;
        serverValidationError: string;
        isBusy = false;
        submitButtonName: string;
        productList: ProductVm[];
    
        constructor(
            private dataService: AccountProductService,
            private route: ActivatedRoute,
            private router: Router
        ) { }
    
        async ngOnInit(): Promise<void> {
            this.model = new EditAccountProductVm();
            this.model.id = +this.route.snapshot.params['id'];
            console.log('ID:', this.model.id);
            if (this.model.id > 0) {
                this.submitButtonName = "Save";
                this.isBusy
                this.model = await this.dataService.getEditVm(this.model.id);
                this.isBusy = false;
            } else {
                this.submitButtonName = "Create";
                this.isBusy = true;
                this.model = await this.dataService.getForAddVm();
                this.isBusy = false;
                this.productList = this.model.products; // Store the original product list
                this.model.products = new Array<ProductVm>(); // Blank out the products so we can filter them later
            }
        }
    
        async submit(): Promise<void> {
            this.serverValidationError = '';

            this.isBusy = true;
            await this.dataService.save(this.model).catch(e => this.serverValidationError = e);
            this.isBusy = false;
            if (this.serverValidationError) return;
    
            this.navigateBack();
        }
  
        navigateBack(): void {
            this.router.navigate(['/account-product'])
        }

        async accountChanged(): Promise<void> {
            this.model.accountId = this.model.accountId;
            this.model.accountName = this.model.accountName;
            this.isBusy = true;
            const accountData = await this.dataService.getListForAccountVm(this.model.accountId);
            this.model.products = this.productList; // Reset to original product list
            //console.log('Reset model products to original product list, total products: ' + this.model.products.length);
            //console.log('Product to remove count: ' + accountData.length);
            
            // Filter the products based on the selected account (removing existing products for the account)
            if (accountData && accountData.length > 0) {
                this.model.products = this.model.products.filter(p => !accountData.includes(p.id));
                //console.log('Removed ' + (this.productList.length - this.model.products.length) + ' products from the list, ' + this.model.products.length + ' products remaining.');
            }
            this.isBusy = false;
        }
 }